const bundler = [{
  value: 'bcq-ui',
  disabled: true,
  selected: true,
  dependencies: []
}, {
  value: 'bcq-app',
  disabled: true,
  selected: true,
  dependencies: [
    'reactive-style'
  ]
}, {
  value: 'alert',
  dependencies: [
    'table-layout',
    'icon',
    'container'
  ]
}, {
  value: 'ambient-image',
  dependencies: []
}, {
  value: 'api-explorer',
  dependencies: [
    'container',
    'card',
    'toolbar',
    'icon',
    'dropdown',
    'tab',
    'alert'
  ]
}, {
  value: 'app-release-notes',
  dependencies: [
    'collapsible'
  ]
}, {
  value: 'async-form',
  dependencies: []
}, {
  value: 'autocomplete',
  dependencies: [
    'async-form',
    'container',
    'text-field',
    'card',
    'list'
  ]
}, {
  value: 'avatar',
  dependencies: [
    'icon'
  ]
}, {
  value: 'badge',
  dependencies: []
}, {
  value: 'badge-generator',
  dependencies: [
    'table-layout',
    'icon'
  ]
}, {
  value: 'banner',
  dependencies: [
    'table-layout'
  ]
}, {
  value: 'bottom-navigation',
  dependencies: [
    'table-layout'
  ]
}, {
  value: 'bottom-sheets',
  dependencies: []
}, {
  value: 'brand-color',
  dependencies: [
    'reactive-style'
  ]
}, {
  value: 'breadcrumbs',
  dependencies: [
    'breadcrumbs',
    'breadcrumbs-item'
  ]
}, {
  value: 'btn',
  dependencies: [
    'icon'
  ]
}, {
  value: 'btn-group',
  dependencies: [
    'icon',
    'table-layout'
  ]
}, {
  value: 'card',
  dependencies: [
    'card-actions',
    'card-text',
    'card-title'
  ]
}, {
  value: 'carousel',
  dependencies: [
    'radio-group',
    'table-layout',
    'icon',
    'carousel-slide',
    'divider',
    'container'
  ]
}, {
  value: 'checkbox',
  dependencies: [
    'table-layout',
    'icon'
  ]
}, {
  value: 'chessboard',
  dependencies: [
    'card',
    'table-layout',
    'flex',
    'reactive-style'
  ]
}, {
  value: 'chip',
  dependencies: [
    'table-layout',
    'avatar',
    'icon'
  ]
}, {
  value: 'chip-input',
  dependencies: [
    'async-form',
    'table-layout',
    'icon',
    'chip',
    'text-field',
    'btn'
  ]
}, {
  value: 'chord-diagram',
  dependencies: [
    'table-layout',
    'avatar'
  ]
}, {
  value: 'collapsible',
  dependencies: [
    'collapsible-item',
    'icon',
    'container',
    'divider',
    'table-layout'
  ]
}, {
  value: 'color-palette',
  dependencies: [
    'card',
    'radio-group',
    'reactive-style'
  ]
}, {
  value: 'color-picker',
  dependencies: [
    'avatar',
    'brand-color'
  ]
}, {
  value: 'container',
  dependencies: []
}, {
  value: 'context-menu',
  dependencies: [
    'card',
    'list',
    'table-layout',
    'icon'
  ]
}, {
  value: 'cookie-consent',
  dependencies: [
    'bottom-sheets',
    'table-layout',
    'btn',
    'icon'
  ]
}, {
  value: 'data-table',
  dependencies: [
    'card',
    'flex',
    'text-field',
    'divider',
    'checkbox',
    'pager',
    'dropdown',
    'btn',
    'icon'
  ]
}, {
  value: 'datetime-picker',
  dependencies: [
    'card',
    'tab',
    'datetime-picker-time',
    'datetime-picker-date'
  ]
}, {
  value: 'dialog-box',
  dependencies: [
    'card',
    'table-layout',
    'btn',
    'icon',
    'divider',
    'reactive-style'
  ]
}, {
  value: 'divider',
  dependencies: []
}, {
  value: 'dropdown',
  dependencies: [
    'container',
    'text-field-label',
    'table-layout',
    'icon',
    'line-ripple',
    'card',
    'checkbox'
  ]
}, {
  value: 'emoji',
  dependencies: []
}, {
  value: 'empty',
  dependencies: [
    'container',
    'icon',
    'divider'
  ]
}, {
  value: 'fab',
  dependencies: [
    'btn'
  ]
}, {
  value: 'flag',
  dependencies: []
}, {
  value: 'flex',
  dependencies: [
    'flex-col'
  ]
}, {
  value: 'gauge',
  dependencies: []
}, {
  value: 'icon',
  dependencies: []
}, {
  value: 'inline-editor',
  dependencies: [
    'card',
    'container',
    'icon'
  ]
}, {
  value: 'lazy-image',
  dependencies: [
    'icon'
  ]
}, {
  value: 'line-ripple',
  dependencies: []
}, {
  value: 'list',
  dependencies: [
    'list-item',
    'list-item-avatar',
    'list-item-content',
    'list-item-content-sub-title',
    'table-layout',
    'list-item-content-title',
    'list-item-icon'
  ]
}, {
  value: 'loading-overlay',
  dependencies: [
    'icon'
  ]
}, {
  value: 'lorem-ipsum',
  dependencies: []
}, {
  value: 'macos-dock',
  dependencies: [
    'table-layout',
    'badge',
    'macos-dock-app-marker',
    'reactive-style'
  ]
}, {
  value: 'menu-list',
  dependencies: [
    'btn',
    'avatar',
    'card'
  ]
}, {
  value: 'meta-tags',
  dependencies: []
}, {
  value: 'multiline-ellipsis',
  dependencies: [
    'container'
  ]
}, {
  value: 'navbar',
  dependencies: [
    'reactive-style'
  ]
}, {
  value: 'navigator-online',
  dependencies: []
}, {
  value: 'nightshift',
  dependencies: [
    'reactive-style'
  ]
}, {
  value: 'notification',
  dependencies: [
    'alert'
  ]
}, {
  value: 'otp-input',
  dependencies: [
    'card',
    'table-layout',
    'reactive-style',
    'text-field',
    'async-form'
  ]
}, {
  value: 'qr-code',
  dependencies: []
}, {
  value: 'pager',
  dependencies: [
    'btn'
  ]
}, {
  value: 'parallax',
  dependencies: [
    'btn',
    'parallax-controls',
    'line-ripple',
    'radio-group',
    'radio',
    'parallax-item',
    'table-layout'
  ]
}, {
  value: 'password-generator',
  dependencies: [
    'card',
    'flex',
    'divider',
    'text-field',
    'btn'
  ]
}, {
  value: 'password-strength-meter',
  dependencies: [
    'table-layout'
  ]
}, {
  value: 'progressbar',
  dependencies: [
    'table-layout',
    'icon'
  ]
}, {
  value: 'radio-group',
  dependencies: [
    'table-layout',
    'icon',
    'radio'
  ]
}, {
  value: 'rating',
  dependencies: [
    'icon'
  ]
}, {
  value: 'reactive-style',
  dependencies: []
}, {
  value: 'reflection',
  dependencies: []
}, {
  value: 'ribbon',
  dependencies: [
    'card',
    'container',
    'icon',
    'tab',
    'table-layout',
    'btn-group',
    'menu-list',
    'list',
    'dropdown',
    'color-picker',
    'checkbox',
    'radio-group',
    'text-field',
    'reactive-style'
  ]
}, {
  value: 'skeleton-loader',
  dependencies: []
}, {
  value: 'slider',
  dependencies: [
    'table-layout',
    'reactive-style'
  ]
}, {
  value: 'snackbar',
  dependencies: [
    'table-layout',
    'btn'
  ]
}, {
  value: 'social-bar',
  dependencies: [
    'icon',
    'brand-color'
  ]
}, {
  value: 'sparklines',
  dependencies: []
}, {
  value: 'stats',
  dependencies: [
    'icon'
  ]
}, {
  value: 'steps',
  dependencies: [
    'icon',
    'table-layout',
    'avatar',
    'line-ripple'
  ]
}, {
  value: 'switcher',
  dependencies: []
}, {
  value: 'system-bar',
  dependencies: [
    'table-layout'
  ]
}, {
  value: 'tab',
  dependencies: [
    'table-layout',
    'icon',
    'carousel',
    'line-ripple',
    'tab-panel'
  ]
}, {
  value: 'table-layout',
  dependencies: [
    'row',
    'cell'
  ]
}, {
  value: 'terminal',
  dependencies: [
    'card',
    'async-form',
    'text-field',
    'color-picker'
  ]
}, {
  value: 'text-field',
  dependencies: [
    'text-field-label',
    'table-layout',
    'line-ripple',
    'icon'
  ]
}, {
  value: 'theme-colors',
  dependencies: [
    'brand-color'
  ]
}, {
  value: 'time-picker',
  dependencies: [
    'card',
    'icon',
    'reactive-style',
    'table-layout',
    'text-field'
  ]
}, {
  value: 'time-picker-field',
  dependencies: [
    'text-field',
    'container',
    'time-picker'
  ]
}, {
  value: 'timeline',
  dependencies: [
    'table-layout',
    'timeline-item',
    'timeline-item-bar',
    'icon',
    'timeline-item-date',
    'timeline-item-info'
  ]
}, {
  value: 'toolbar',
  dependencies: [
    'toolbar',
    'table-layout',
    'toolbar-actions',
    'toolbar-icon',
    'toolbar-title'
  ]
}, {
  value: 'transfer',
  dependencies: [
    'container',
    'flex',
    'card',
    'btn',
    'checkbox',
    'list'
  ]
}, {
  value: 'treeview',
  dependencies: [
    'treeview-item',
    'container',
    'icon',
    'checkbox'
  ]
}, {
  value: 'upload',
  dependencies: [
    'table-layout',
    'card',
    'container',
    'alert',
    'list',
    'avatar',
    'icon',
    'btn'
  ]
}, {
  value: 'vid',
  dependencies: []
}, {
  value: 'visual-feedback-icon',
  dependencies: [
    'icon'
  ]
}]

export default bundler



// WEBPACK FOOTER //
// ./src/helpers/bundler.js